import { Api } from './Api';

export class Auth {
  // static getStripePrices(payload: 'aud' | 'eur' | 'gbp'): ReturnType<typeof Api.get> {
  static getStripePrices(payload: {currencyType: 'aud' | 'eur' | 'gbp', temporary: boolean}): ReturnType<typeof Api.get> {
    const price = payload.currencyType || 'aud';
    return Api.get(`auth/stripe_prices/?currency=${price}&temporary=${payload.temporary}`);
  }
  static registerCompany(body: any): ReturnType<typeof Api.post> {
    return Api.post('auth/sign-up/enterprise/', {
      connected_to_et: body.connected_to_et,
      country: body.country,
      clinic_name: body.clinic_name,
      email: body.email,
      full_name: body.full_name,
      number_of_machines: body.number_of_machines,
      number_of_clinics: body.number_of_clinics,
      password: body.password,
      position_title: body.position_title,
      phone_number: body.phone_number,
      country_code: body.country_code,
      domain: body.domain,
    });
  }
  static registerClinic(body: any): ReturnType<typeof Api.post> {
    return Api.post('auth/sign-up/standard/', {
      billing_type: body.billing_type,
      clinic_name: body.clinic_name,
      email: body.email,
      full_name: body.full_name,
      number_of_machines: body.number_of_machines,
      password: body.password,
      position_title: body.position_title,
      phone_number: body.phone_number,
      country_code: body.country_code,
      country: body.country,
      domain: body.domain,
    });
  }
  static login(body: any): ReturnType<typeof Api.post> {
    return Api.post('auth/token/obtain/', {
      email: body.email,
      password: body.password,
    });
  }
  static confirmEmail(token: string): ReturnType<typeof Api.put> {
    return Api.put('auth/confirm_email/', {
      token,
    });
  }
  static signupSubClinic(body: any): ReturnType<typeof Api.post> {
    return Api.post('auth/sign-up/sub_clinic/', body);
  }

  static forgotPassword(email: string): ReturnType<typeof Api.post> {
    return Api.post('auth/forgot_password/', {
      email,
    });
  }

  static createNewPassword(
    token: string,
    password: string,
    confirmPassword: string,
  ): ReturnType<typeof Api.post> {
    return Api.post('auth/reset_password/', {
      token,
      password,
      confirm_password: confirmPassword,
    });
  }
}
